import useSWR from 'swr';
import { PricingResponse } from '../types/Pricing';
import api from '../utils/api';

// Use SWR with deduplication - only fetch once per session
// SWR automatically deduplicates requests with the same key across all components
export default function usePricingPlans() {
  const { data, error, isLoading } = useSWR<{ data: PricingResponse }>(
    '/subscriptions/v1/plans',
    api,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000 * 60, // 1 hour - effectively once per session
      revalidateIfStale: false // Don't revalidate if data exists
    }
  );
  
  const allPlans = data?.data?.plans;
  return {
    pricingPlans: allPlans,
    isLoading,
    isError: error
  };
}
